var DocumentModule = (function () {
    function DocumentModule() {
    }
    return DocumentModule;
}());
export { DocumentModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document.module.ts.pre-build-optimizer.js